export interface LoggedError {
  stage: string;
  message: string;
  atMs: number;
}

/**
 * Errors are never swallowed: everything caught is recorded here and surfaced in
 * Diagnostics as `lastError`.
 */
export class ErrorLog {
  private entries: LoggedError[] = [];
  private readonly limit = 20;

  record(stage: string, error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);
    this.entries.push({ stage, message, atMs: Date.now() });
    if (this.entries.length > this.limit) {
      this.entries.shift();
    }
    // Surface in the console too — silent failures are worse than noisy ones.
    console.error(`[web-improvisation] ${stage}: ${message}`);
  }

  get last(): LoggedError | null {
    return this.entries.at(-1) ?? null;
  }

  get lastText(): string | null {
    const entry = this.last;
    return entry === null ? null : `${entry.stage}: ${entry.message}`;
  }

  clear(): void {
    this.entries = [];
  }
}
